// export const API_VERSION = "v1.0";
// // export const BASEURL = "https://api.cinepolisgulf.com/api/";
// // export const BASEURL = "http://localhost:8001/api/";
// export const ASSETS_BASEURL = "http://localhost:8001/";
// // export const ASSETS_BASEURL = "https://api.cinepolisgulf.com/";
// // export const BASEURL = "https://uat-api-cinepolis.cinepolisgulf.com/api/";
// // export const BASEURL = "https://api.cinepolisgulf.com/api/";
// export const BASEURL = "https://api-gcc-oci.enpointe.io/api/";

// // export const BASEURL = "https://api-uat-india-cinepolis.binarynumbers.io/api/";
// // export const BASEURL = "http://164.52.200.186:8001/api/";
// // export const BASEURL = "https://cinepolis-backend-dev.binarynumbers.io/api/";
// export const LANDING_PAGE = "https://cinepolis-app-dev.binarynumbers.io/";
// export const APP_LANDING_PAGE = "https://cinepolis-app-dev.binarynumbers.io/";
// export const GOOGLE_MAP_API_KEY = "AIzaSyAG5fxp_0_R9s559gzQRDREtfeAYPiIu4Q";
// export const PAYFORT = {
//     merchant_identifier: '751b7057',
//     access_code: 'tPgNnkJXpQDRaRpmIuDz',
//     payfort_url: 'https://sbcheckout.payfort.com/FortAPI/paymentPage',
// }


// API version used throughout the app
export const API_VERSION = process.env.REACT_APP_API_VERSION;

// Main API endpoint
export const BASEURL = process.env.REACT_APP_BASEURL;

// URL used for loading assets like images and trailers
export const ASSETS_BASEURL = process.env.REACT_APP_ASSETS_BASEURL;

// Landing page for general use (e.g., redirects)
export const LANDING_PAGE = process.env.REACT_APP_LANDING_PAGE;

// App-specific landing page (can be same as LANDING_PAGE)
export const APP_LANDING_PAGE = process.env.REACT_APP_APP_LANDING_PAGE;

// Google Maps API Key
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

// PayFort payment configuration for checkout integration
export const PAYFORT = {
  merchant_identifier: process.env.REACT_APP_PAYFORT_MERCHANT_IDENTIFIER,
  access_code: process.env.REACT_APP_PAYFORT_ACCESS_CODE,
  payfort_url: process.env.REACT_APP_PAYFORT_URL,
};
